/**
 * Service layer — permit activity logged by posting, the duplicate guard, and the client's
 * Permitting card (docs/OPERATING_MODEL.md, build step 4 slice B). Talks to /api/permitting only.
 */

async function authToken() {
  if (typeof window === 'undefined') return null
  for (let i = 0; i < 20; i++) {
    if (typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* not ready */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}
async function post(body) {
  const token = await authToken()
  const res = await fetch('/api/permitting', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || ('Request failed: ' + res.status))
  return json
}

/** What posting this milestone logs in the Permits section: { kind, activityType, date, plannedNext,
 *  reviews: [{ id, agency, permitType, permitId, status, linked }], alreadyLogged, needsIntake }. */
export function getPostingPermitContext(milestoneId, date) { return post({ action: 'postingContext', milestoneId, date }) }

/** After activities were logged (by posting, or by hand in the Permits log): record where they came
 *  from, update the client's Permitting card, email subscribers (not when `silent`). */
export function reportActivitiesLogged({ activityIds, source, milestoneId, expectedSource, linkReviewIds, memberName, silent }) {
  return post({ action: 'logged', activityIds, source, milestoneId, expectedSource, linkReviewIds, memberName, silent: !!silent })
}

/** A review's last 60 days of activity with where each came from — the duplicate guard. */
export function getRecentReviewActivity(reviewId) { return post({ action: 'recent', reviewId }) }

/** Who logging this would reach: { hasJourney, subscribers, held, projectName, clientLabel }. */
export function getClientReach({ milestoneId, reviewId, activityType }) { return post({ action: 'reach', milestoneId, reviewId, activityType }) }

/** Plain words for an activity type, for staff-facing notes (the internal strings carry emoji). */
export function activityPlain(t) { return String(t || '').replace(/^[^A-Za-z]+/, '') }
